import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
import Vue from 'vue';

var axios_instance = get_axios_instance(api_variables.SERVICE_PAYROLL_CYCLE);

const _pk_name = 'id';

const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    payCycleId: ''
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    payCycleId: (state) => {
        return state.payCycleId;
    }
};
const mutations = {
    set: (state, [payload, id]) => {
        Vue.set(state.entityWiseData, id, payload);
    },

    addEntity: (state, [payload, id]) => {
        state.entityWiseData[id] = payload;
    },

    updateEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.entityWiseData[id].length; i++) {
            if (state.entityWiseData[id][i][_pk_name] === payload.id) {
                state.entityWiseData[id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.entityWiseData[id].length; i++) {
            if (state.entityWiseData[id][i][_pk_name] == payload) {
                state.entityWiseData[id].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.payCycleId = payload.id;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(``, {
                params: {
                    le_id: payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', [res.data.payload.data, payload]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.post('/', payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('addEntity', [res.data.payload.data, payload.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.put('/', payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('updateEntityById', [res.data.payload.data, res.data.payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, id]) {
        try {
            commit('setDeleting', true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit('setDeleting', false);
            if (res.status == 200) {
                commit('removeEntityById', [payload.id, id]);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        try {
            commit('setEditMode', payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};